import {CommonMessages} from '../common.messages';

export const PanelSettingsRolesEditMessages = {
    GetRoleFailed: {
        key: 'GetRoleFailed',
        message: 'Error while communication with the server. Can\'t get role.'
    },
    RoleNotFound: {
        key: 'RoleNotFound',
        message: 'Error while communication with the server. Unable to find role.'
    },
    GetPermissionsFailed: {
        key: 'GetPermissionsFailed',
        message: 'Error while communication with the server. Can\'t get available permissions for role.'
    },
    PermissionsNotFound: {
        key: 'PermissionsNotFound',
        message: 'Error while communication with the server. Unable to find permissions for role.'
    },
    InvalidPermissions: {
        key: 'InvalidPermissions',
        message: 'Selected permissions are invalid.'
    },
    RequiredPermissions: {
        key: 'RequiredPermissions',
        message: 'Selection of more than one permission is required.'
    },
    RoleUpdateFailed: {
        key: 'RoleUpdateFailed',
        message: 'Error while role update. Unable to update role.'
    },
    RoleUpdateSucceed: {
        key: 'RoleUpdateSucceed',
        message: 'Role is successfully updated.'
    },
    RolePermissionsUpdateFailed: {
        key: 'RolePermissionsUpdateFailed',
        message: 'Error while role permissions update. Unable to update role permissions.'
    },
    ...CommonMessages
};
